export const SET_PRODUCT_FILTER = 'SET_PRODUCT_FILTER'
export const RE_INITIALIZE_PRODUCT_FILTER = 'RE_INITIALIZE_PRODUCT_FILTER'
